/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualificationTypeModel } from '../../models/qualification-type-model';

export interface QualificationTypePost$Params {
      body?: QualificationTypeModel
}

export function qualificationTypePost(http: HttpClient, rootUrl: string, params?: QualificationTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, qualificationTypePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<string>;
    })
  );
}

qualificationTypePost.PATH = '/QualificationType';
